import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        index: null,
        latestPostId: null,
        currentPostId: null,
        currentPost: null,
    },
    mutations: {
        UPDATE_INDEX(state, { index, latestPostId }) {
            state.index = index;
            state.latestPostId = latestPostId;
        },
        UPDATE_CURRENT_POST(state, { post, id }) {
            state.currentPostId = id;
            state.currentPost = post;
        },
    },
    actions: {
        init({dispatch}, postId) {
            dispatch('fetchIndex', postId);
        },
        goToPost({dispatch, state}, { postId, putOnHistory }) {
            if (state.index == null || postId > state.latestPostId || postId < 1) {
                return;
            }

            if (putOnHistory) {
                window.history.pushState({
                    postId: postId,
                }, null, `/${postId}`);
            }

            dispatch('fetchPost', postId);
        },
        async fetchIndex({commit, dispatch}, postId) {
            const index = await fetch('https://blog.rmy.ch/api/blog/index')
                    .then(response => response.json());
            const latestPostId = index[0].posts[0].id;
            const initialPostId = postId ? parseInt(postId) : latestPostId;
            commit('UPDATE_INDEX', { index, latestPostId });
            dispatch('fetchPost', initialPostId);
        },
        async fetchPost({commit}, postId) {
            const post = await fetch(`https://blog.rmy.ch/api/blog/posts/${postId}`)
                    .then(response => response.json());
            commit('UPDATE_CURRENT_POST', { post, id: postId });
        },
    },
});
